module.exports = __webpack_public_path__ + "static/media/notest.664c714e.png";